export default __webpack_public_path__ + "post-mail.8db59f671c6ac3cac40eb43f70fd87bc.png";